import {hexToHsva} from '@uiw/color-convert'
import PropTypes from "prop-types";
import CnerLogoSvg from "../../../../lib/components/images/CnerLogoSvg";
import ColorPicker from "../../../../lib/components/colorpicker/ColorPicker";
import InputBase from "./InputBase";
import {FormControl, FormHelperText, InputLabel, OutlinedInput} from "@mui/material";
import Menu from "../menu/Menu";

/**
 * @property string   hex: Farbwert als Hex-Wert: Bsp. #225588
 * @property string[] colors: Schnell-Auswahlfarben: Bsp. ['#f44e3b', '#fe9200', '#fcdc00', '#dbdf00']
 */
class InputColorPicker extends InputBase {

  constructor(props) {
    super(props);
    this.state.hsva = hexToHsva(this.props.hex);
    this.state.hex = this.props.hex;
    this.state.anchorEl = null;
  }

  getValue() {
    return this.state.hex;
  }

  onColorPickerChange(hex) {
    this.onBlur(hex);
    this.fireOnChange(null, hex);
    this.setState({hex: hex});
  }

  onInputClick(e) {
    if (this.state.anchorEl) {
      this.state.anchorEl = null;
    } else {
      this.state.anchorEl = e.currentTarget;
      setTimeout(() => {
        window.addEventListener('click', this.addBackDrop);
      }, 1);
    }
    this.setState(this.state);
  }

  render() {
    const hasError = !!this.state.errorText;
    return <div>
      <FormControl fullWidth error={hasError}>
        <InputLabel htmlFor={this._id}>{this.props.labelElement}</InputLabel>
        <OutlinedInput readOnly
                       id={this._id}
                       value={this.state.hex}
                       endAdornment={<CnerLogoSvg fillColor={this.state.hex}/>}
                       onClick={(e) => this.onInputClick(e)}
                       label={this.props.labelElement}/>
        {hasError && <FormHelperText>{this.state.errorText}</FormHelperText>}
      </FormControl>
      <Menu
        onClose={(e) => this.setState({anchorEl: null})}
        open={Boolean(this.state.anchorEl)}
        anchorEl={this.state.anchorEl}>
        <ColorPicker colors={this.props.colors}
                     onClose={(e) => this.setState({anchorEl: null})}
                     hex={this.state.hex}
                     onChange={(hex) => this.onColorPickerChange(hex)}/>
      </Menu>
    </div>;
  }
}

InputColorPicker.propTypes = {
  className: PropTypes.string,
  iconLeft: PropTypes.node,
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  inputLayout: PropTypes.oneOf(['inline', 'outline', '']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  hex: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string)
}
export default InputColorPicker
